import React from 'react';

import Dialog, {
  DialogHeader,
  DialogContent,
  DialogFooter,
} from '@guestyci/foundation/Dialog';
import TextField from '@guestyci/foundation/TextField';
import FlatButton from '@guestyci/foundation/FlatButton';
import RaisedButton from '@guestyci/foundation/RaisedButton';
import t from '@guestyci/localize/t.macro';

const DirtyWarningDialog = ({ to, handleOk, handleClose }) => (
  <Dialog open={!!to} onClose={handleClose}>
    <DialogHeader>
      {t('Are you sure you want to leave this page?')}
    </DialogHeader>
    <DialogContent>
      <TextField>{t('Your new changes will be lost.')}</TextField>
    </DialogContent>
    <DialogFooter>
      <FlatButton onClick={handleClose}>{t('Stay')}</FlatButton>
      <RaisedButton onClick={() => handleOk(to)}>{t('Leave')}</RaisedButton>
    </DialogFooter>
  </Dialog>
);

export default DirtyWarningDialog;
